import React from 'react'
import Dashboard from '../Dashboard';
import PlanATripPaymentMain from './PlanATripPaymentMain'

export default function PlanATripPayment() {
    return (
        <div>
            <Dashboard cmp={<PlanATripPaymentMain />} />
        </div>
    )
}
